import React, { useContext, useEffect, useState } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import Pagination from 'react-bootstrap/Pagination';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { RestaurantContext } from '../../../../../context/RestaurantContext';
import { ThemeContext } from '../../../../../context/ThemeContext';
import RejectedRequestCard from './RejectedRequestCard';
import ProgressBar from '../../../Loader';
import { AuthContext } from '../../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const RejectedRequest = () => {
  const { apiGlobal } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [rejectedRestaurant, setRejectedRestaurant] = useState([]);
  const [filterRestaurant, setFilterRestaurant] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { setRefresh, refresh } = useContext(RestaurantContext);
  const { currentTheme } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(true);

   // Pagination state
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 5;



  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${apiGlobal}/restaurant_rejected_list.php`);
      const data = await response.json();
  
      // console.log('Data:', data);
  
      if (data.status && data.message === 'Success') {
        // console.log('Data fetched:', data.data);
        setRejectedRestaurant(data.data);
        setFilterRestaurant(data.data);
      } else {
        console.log('No data fetched');
        setFilterRestaurant([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
    } finally {
      setIsLoading(false);
    }
  };
  


  useEffect(() => {
    // console.log('Refreshing data...');
    fetchData();
  }, [refresh, sideBarRefresh?.adminRestaurantRejectedRefresh]);
  
    // use Effect to add keyframes for the pulse animation
    useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []); 

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }
  

  // if (rejectedRestaurant.length <= 0) {
  //   return (
  //     <div>

  //       <div style={{
  //                           textAlign: 'center',
  //               padding: '50px',
  //               backgroundColor: '#f8d7da',
  //               borderRadius: '8px',
  //               marginTop: '20px',
  //                           color: '#721c24',
  //               fontSize: '16px',
  //                         }}
  //       >
  //         <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
  //         <p>No Rejected Request </p>
  //       </div>
  //     </div>
  //   );
  // }

 
  
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    if (query) {
      const filteredData = rejectedRestaurant.filter(meal => meal?.name.toLowerCase().includes(query.toLowerCase()));
      setFilterRestaurant(filteredData); // Set filtered data when search query exists
    } else {
      setFilterRestaurant(rejectedRestaurant); // Reset to original list when no query
    }
  };

  
  

  const refreshHandler = () => {
    fetchData();
    setSearchQuery('');
  };

    

 


    // Handle page change
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
    // Pagination Logic - Slice data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
    // Use filteragent for pagination, not agent
    const currentItems = filterRestaurant.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages should be based on filteragent length, not agent
    const totalPages = Math.ceil(filterRestaurant.length / itemsPerPage);

  return (
    <div>
      <Container>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
        marginBottom: '5px',
      }}
        >
          <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
          <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
          <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography>
        </Breadcrumbs>
      </Container>
      <Container className="bg-white" style={{ padding: '20px' }}>
        
        <Row>
          <Col md={12} />
        </Row>  
        <Row>
          <div style={{
                   display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                 }}
          >
            <Form.Control
              type="text"
              placeholder="Search by Name......"
              value={searchQuery}
              onChange={handleSearch}
              style={{
                       height: '30px',
                       marginTop: '5px',
                       borderColor: 'green',
                       flexGrow: 1,
                     }}
            />

            <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
              <Button
                variant="outline-secondary"
                title="Refresh"
                size="sm"
                style={{ marginLeft: '10px' }}
                onClick={refreshHandler}
              >
                <span className="lnr lnr-sync" />
              </Button>
            </ButtonGroup>
      
          </div>
        </Row>
        <Row>
          <Container>
            {filterRestaurant.length > 0 ? (
            currentItems.map(resData => (
              <RejectedRequestCard
                key={resData.id}
                id={resData.id}
                name={resData.user_name}
                userPhone={resData.user_phone}
                userEmail={resData.user_email}
                uin={resData.uin}
                country={resData.country_name}
                accName={resData.acc_name}
                accNumber={resData.account_no}
                ifscCode={resData.ifsc_code}
                remark={resData.reject_reason}
                branch={resData.branch}
                bank={resData.bank}
                accCity={resData.acc_city}
                accCountry={resData.acc_country_name}
                photo={resData.photo}
                setRefresh={setRefresh}
              />
            ))
          ) : (
                            // If search results are empty
            <div style={{
                              textAlign: 'center',
                  padding: '50px',
                  backgroundColor: '#f8d7da',
                  borderRadius: '8px',
                  marginTop: '20px',
                              color: '#721c24',
                  fontSize: '16px',
                            }}
            >
              <div
                style={{
              fontSize: '48px',
              marginBottom: '20px',
              color: '#e63946',
              animation: 'pulse 1.5s infinite ease-in-out',
              display: 'inline-block',
              }}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No Rejected requests available'}</p>
            </div>
                          )}
          </Container>
        </Row>
        {/* Pagination Controls */}
        <div
          style={{
          // position: 'fixed', 
          bottom: '20px', 
          right: '20px', 
          zIndex: 999, 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
        }}
        >
          {filterRestaurant.length > 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
          ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
           )}
          
        </div>
      </Container>
    </div>
   
  );
};

export default RejectedRequest;
